import Graph from '../Graph'

const ReferenceLine = ({ name, rect, right, bottom, y, color, ...props }) => {
	return (
		<>
			<Graph
				{...props}
				points={[{type : 'point', x : 0, y : y}, {type : 'point', x : 9, y : y}]}
				rect={rect}
				color={color}
			/>
		</>
	)
}

export default ReferenceLine
